import React, { useState, useEffect } from "react";
import moment from "moment";
import queryStringService from "app/services/queryStringService";
import {
  getCreditLimitSettle,
  exportCreditList,
} from "app/services/SearchService";
import { AiFillFileExcel } from "react-icons/ai";
import { Breadcrumb } from "@gull";
import { Button, Col, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import AutoCompleteCreditList from "./AutoCompleteVreditList";
import HandyScroll from "app/common/Scroll";

const dateFormat = "YYYY-MM-DD";
const dateTimeFormat = "YYYY-MM-DD HH:mm:ss";

const CreditLimitSettle = () => {
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [dataCount, setDataCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [FromDate, setFromDate] = useState("");
  const [ToDate, setToDate] = useState("");
  const [MemId, setMemId] = useState("");

  const dateFormater = (cell, row) => {
    return moment(cell).format("MMMM Do YYYY, h:mm");
  };

  const transactionModeFormatter = (cell, row) => {
    if (row.transactionMode === "Debit") {
      return (
        <div>
          <span className="text-danger">Debit</span>{" "}
          <img
            src="/assets/images/debit 1.png"
            alt=""
            width={40}
            height={30}
            className="p-0 m-0"
          />
        </div>
      );
    } else {
      return (
        <div>
          <span className="text-success">Credit</span>
          <img
            src="/assets/images/credit 1.png"
            alt=""
            width={40}
            height={30}
            className="p-0 m-0"
          />
        </div>
      );
    }
  };

  const transactionAmountFormatter = (cell, row) => {
    return <span> ₹ {row.transactionAmount} </span>;
  };
  const memDetails = (row) => {
    return (
      <div>
        <strong>Merchant Name:</strong> {row.memberFullName}
        <strong>Company Name:</strong> {row.company}
      </div>
    );
  };
  const creditLock = (row) => {
    return !row.creditLock ? "Unlock" : "Lock";
  };
  const columns = [
    {
      dataField: "masterMember",
      text: "User Name",
      headerStyle: (colum, colIndex) => {
        return { width: "200px", fontSize: "13px", textAlign: "center" };
      },
      formatter: memDetails,
    },

    {
      dataField: "corelationId",
      text: "Correlation Id",
      headerStyle: (colum, colIndex) => {
        return { width: "200px", fontSize: "13px", textAlign: "center" };
      },
    },
    {
      dataField: "creditLimitProvided",
      text: "Credit Limit",
      headerStyle: (colum, colIndex) => {
        return { width: "200px", fontSize: "13px", textAlign: "center" };
      },
      // formatter: transactionModeFormatter,
    },
    {
      dataField: "creditGivenDate",
      text: "Credit Given Date",
      headerStyle: (colum, colIndex) => {
        return { width: "200px", fontSize: "13px", textAlign: "center" };
      },
      formatter: dateFormater,
    },
    {
      dataField: "creditLimitUsed",
      text: "Available Credit Limit",
      headerStyle: (colum, colIndex) => {
        return { width: "200px", fontSize: "13px", textAlign: "center" };
      },
      // formatter: transactionModeFormatter,
    },
    {
      dataField: "creditLimitUseDate",
      text: "Available Credit limit Date",
      headerStyle: (colum, colIndex) => {
        return { width: "200px", fontSize: "13px", textAlign: "center" };
      },
      formatter: dateFormater,
    },
    {
      dataField: "creditEndDate",
      text: "Expire Credit limit Date",
      headerStyle: (colum, colIndex) => {
        return { width: "200px", fontSize: "13px", textAlign: "center" };
      },
      formatter: dateFormater,
    },
    {
      dataField: "transactionDate",
      text: "Trans Date",
      headerStyle: (colum, colIndex) => {
        return { width: "200px", fontSize: "13px", textAlign: "center" };
      },
      formatter: dateFormater,
    },
    {
      dataField: "creditLock",
      text: "Credit Lock",
      headerStyle: (colum, colIndex) => {
        return { width: "200px", fontSize: "13px", textAlign: "center" };
      },
      formatter: creditLock,
    },

    {
      dataField: "creditRemark",
      text: "Remark",
      headerStyle: (colum, colIndex) => {
        return { width: "200px", fontSize: "13px", textAlign: "center" };
      },
      //formatter: remarksFormatter,
    },
  ];

  const loadCredit = async () => {
    const query = queryStringService.getQueryStringFromObj({
      pageNumber: page,
      pageSize: sizePerPage,
      FromDate,
      ToDate,
      MemId,
    });

    if (dataCount !== 0) {
      setLoading(true);
    }
    const response = await getCreditLimitSettle(query);

    const responseData = response.data.data;
    const paggingData = JSON.parse(response.headers["x-pagination"]);

    setData(responseData);
    setDataCount(paggingData.TotalCount);
    setPage(paggingData.CurrentPage);
    setSizePerPage(paggingData.PageSize);
    setLoading(false);
  };

  const resetTableHandler = async () => {
    const query = queryStringService.getQueryStringFromObj({
      pageNumber: page,
      pageSize: sizePerPage,
    });

    if (dataCount !== 0) {
      setLoading(true);
    }
    const response = await getCreditLimitSettle(query);

    const responseData = response.data.data;
    const paggingData = JSON.parse(response.headers["x-pagination"]);

    setData(responseData);
    setDataCount(paggingData.TotalCount);
    setPage(paggingData.CurrentPage);
    setSizePerPage(paggingData.PageSize);
    setLoading(false);
  };

  useEffect(() => {
    loadCredit();
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [page, sizePerPage]);

  // ... Other component code ...
  const rowStyle = (row, rowIndex) => {
    const style = {};
    style.textAlign = "center";
    style.fontWeight = "600";
    style.verticalAlign = "center";
    return style;
  };
  const NoDataIndication = () => {
    //alert(loading);
    if (loading) {
      return (
        <div className="jumbotron jumbotron-fluid min-vh-80 m-0 bg-white"></div>
      );
    } else {
      return (
        <div className="jumbotron min-vh-80 text-middle m-0 text-center d-flex flex-column justify-content-center">
          <span className="align-middle"></span>
          <p> No Data Found</p>
        </div>
      );
    }
  };
  const refreshFilter = async () => {
    setFromDate("");
    setToDate("");
    setMemId("");
    await resetTableHandler();
  };

  const handleTableChange = async (type, { page, sizePerPage }) => {
    setPage(page);
    setSizePerPage(sizePerPage);
    await loadCredit();
  };

  const handleSearch = async () => {
    setPage(1);
    setSizePerPage(10);
    await loadCredit();
  };

  const exportCreditList = async () => {
    const query = queryStringService.getQueryStringFromObj({
      FromDate,
      ToDate,
      MemId,
    });
    if (dataCount !== 0) {
      setLoading(true);
    }

    const response = await exportCreditList(query);
    if (response) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `${moment().toISOString()}_CreditList.xlsx`,
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    setLoading(false);
  };
  const handleExport = async () => {
    setPage(1);
    setSizePerPage(10);
    await exportCreditList();
  };

  const handleSearchChanges = (e) => {
    const { name, value } = e.target;
    if (name === "FromDate") {
      setFromDate(value);
    } else if (name === "ToDate") {
      setToDate(value);
    } else if (name === "MemId") {
      setMemId(value);
    }
    // setTimeout(async () => {
    //   await loadCredit();
    // }, 10);
  };
  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange,
  }) => (
    <>
      <label className="mr-2">Page Size</label>
      <div className="btn-group mr-4" role="group">
        {options.map((option) => {
          const isSelect = currSizePerPage === `${option.page}`;
          return (
            <button
              key={option.text}
              type="button"
              onClick={() => onSizePerPageChange(option.page)}
              className={`btn btn-sm ${
                isSelect ? "btn-primary h-75" : "btn-light h-75"
              }`}
            >
              {option.text}
            </button>
          );
        })}
      </div>
    </>
  );

  const paginationOptions = {
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    totalSize: dataCount, // You should have dataCount as a state in your functional component
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "15",
        value: 15,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "50",
        value: 50,
      },
    ],
    sizePerPageRenderer,
  };
  return (
    <>
      <div>
        <Helmet>
          <title>Credit Limit List</title>
        </Helmet>
        <Breadcrumb
          routeSegments={[{ name: "Credit Limit List" }]}
        ></Breadcrumb>

        <div className="card card-body text-left " id="transactionHistory">
          <div className="card-body p-0 mr-2">
            <div className=" mx-auto mb-2">
              <div className="bookingList-header">
                <div className="row">
                  <div className="col-12 col-md-3">
                    <div>
                      <div className="form-group">Date From</div>
                      <input
                        type="date"
                        className="form-control"
                        value={FromDate}
                        data-date=""
                        // data-date-format="YYYY-MM-DD"
                        name="FromDate"
                        onChange={handleSearchChanges}
                        max={moment().format("YYYY-MM-DD")}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-3">
                    <div>
                      <div className="form-group">Date To</div>
                      <input
                        type="date"
                        className="form-control"
                        data-date=""
                        // data-date-format="YYYY-MM-DD"
                        value={ToDate}
                        name="ToDate"
                        onChange={handleSearchChanges}
                        max={moment().format("YYYY-MM-DD")}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-3">
                    <div className="form-group">Search</div>
                    <AutoCompleteCreditList
                      handleChangeOptions={(id) => {
                        setMemId(id);
                        // setTimeout(async () => {
                        //   await loadCredit();
                        // }, 10);
                      }}
                      name="MemId"
                      value={MemId}
                    />
                  </div>

                  <div
                    className="col-12 col-md-3 d-flex justify-content-end mb-3 text-end "
                    style={{ marginTop: "3%" }}
                  >
                    <button
                      className="btn btn-primary  "
                      onClick={handleSearch}
                    >
                      search
                    </button>
                    <button
                      className="btn btn-primary mx-1"
                      onClick={refreshFilter}
                    >
                      Refresh
                    </button>
                    <Button
                      variant="outline-primary"
                      //className="ml-2"
                      onClick={handleExport}
                    >
                      Export Excel
                      <AiFillFileExcel className=" " />
                    </Button>
                  </div>
                </div>
              </div>
            </div>
            <HandyScroll>
              <div
                class="spacious-container"
                data-handy-scroll
                style={{ overflow: "auto" }}
              >
                <BootstrapTable
                  hover
                  remote
                  keyField="sln"
                  data={data}
                  columns={columns}
                  pagination={paginationFactory(paginationOptions)}
                  onTableChange={handleTableChange}
                  noDataIndication={() => <NoDataIndication />}
                  loading={loading}
                  headerClasses="bg-primary text-white"
                  bodyClasses="react-bootstrap-table-next-min-height"
                  rowStyle={rowStyle}
                />
              </div>
            </HandyScroll>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreditLimitSettle;
